import { GameState } from "../../framework/GameState";
import { InputManager } from "../../framework/InputManager";
import { Entity } from "../../framework/Entity";

const PLAYER_SPEED = 160;

export class ExploreState implements GameState {
  key = "explore";
  private input: InputManager | null = null;
  private player: Entity | null = null;

  enter(scene: any): void {
    this.input = scene.inputManager;
    this.player = scene.player;
  }

  exit(_scene: any): void {
    // Stop player movement
    if (this.player && this.player.sprite.body) {
      this.player.sprite.body.setVelocityX(0);
    }
  }

  update(_scene: any, _time: number, _delta: number): void {
    if (!this.input || !this.player) return;

    const sprite = this.player.sprite;

    if (this.input.state.left) {
      sprite.body.setVelocityX(-PLAYER_SPEED);
      sprite.setFlipX(true);
    } else if (this.input.state.right) {
      sprite.body.setVelocityX(PLAYER_SPEED);
      sprite.setFlipX(false);
    } else {
      sprite.body.setVelocityX(0);
    }
  }
}
